import { Component, effect, Input, signal } from '@angular/core';
import { AppModule } from "../../app.module";
import { MapSelect } from "../../map/map-select/map-select";
import { SharedDataService } from '../shareddata.service';
import { IncidentLocation } from '../../models/incident';
import { SettingsService } from '../../settings/settings.service';
import { ClientSettings } from '../../models/client';
import { NotificationService } from '../notification.service';

@Component({
  selector: 'app-location-update',
  imports: [AppModule, MapSelect],
  templateUrl: './location-update.html',
  styleUrl: './location-update.less'
})
export class LocationUpdate {

  public clientSettings: ClientSettings;
  public isVisible = signal<boolean>(false);
  initialLocation: IncidentLocation = new IncidentLocation();

  constructor(private sharedDataService: SharedDataService, private settingsService: SettingsService, private notification: NotificationService) { 

    effect(() => {
      if (this.sharedDataService.flags().mustUpdateLocation === true) {
        this.isVisible.set(true);
        this.settingsService.getSettings().subscribe({
          next: (settings) => {
            this.initialLocation = {
              latitude: settings.lat,
              longitude: settings.lon,
              descriptionShort: '',
              description: null
            };
            this.clientSettings = settings;
          },
          error: (err) => {
            this.notification.handleError(err, 'Failed to load settings.');
          }
        });
      }
    })
   }

  // ngOnInit(): void {
  //   if (this.sharedDataService.flags.mustUpdateLocation === true) {
  //       this.isVisible.set(true);

  //   }
  // }
  public onLocationSelected(location: IncidentLocation | null): void {
    console.log("Selected location:", location);
    if (location) {
      this.initialLocation = location;
      this.clientSettings.lat = location.latitude;
      this.clientSettings.lon = location.longitude;
    }
  }

public handleCancel(): void {
    // Mark as skipped for this session
    this.sharedDataService.flags.update(flags => ({ ...flags, mustUpdateLocation: false }));
    this.isVisible.set(false);
}

  public handleSave(): void {
    console.log("Saving updated location:", this.clientSettings);
    this.settingsService.updateSettings(this.clientSettings).subscribe({
      next: () => {
        this.notification.showSuccess('Location updated successfully.');
        this.isVisible.set(false);
      },
      error: (err) => {
        this.notification.handleError(err, 'Failed to update settings.');
      }
    });
  }
}
